<!--
 * @Author: 仙道
 * @Date: 2022-06-21 16:12:52
 * @LastEditTime: 2022-07-30 23:59:15
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/workbench/components/PanelFour.vue
-->

<template>
    <yw-intelligent-patrol-record-list viewType="noShow" />
</template>

<script>
    import { mapGetters } from 'vuex'
    import GridTable from "../components/table.vue";
    import moment from 'moment'
    import YwIntelligentPatrolRecordList from '@/views/maintenance/YwIntelligentPatrolRecordList'
    export default {
        name: 'PageFour',
        components: {
            GridTable,
            YwIntelligentPatrolRecordList
        },

        // 定义属性
        data() {
            return {
                url: '/maintenance/ywIntelligentPatrolRecord/list',
                queryParams: {},
                columns: [

                    {
                        title: '计划',
                        align: "center",
                        dataIndex: 'planId_dictText'
                    },
                    {
                        title: '复核状态',
                        align: "center",
                        dataIndex: 'reviewStatus_dictText'
                    },
                    {
                        title: '复核人',
                        align: "center",
                        dataIndex: 'reviewPerson_dictText'
                    },
                    {
                        title: '巡检结果',
                        align: "center",
                        dataIndex: 'recordRes_dictText'
                    },
                    {
                        title: '巡检时间',
                        align: "center",
                        dataIndex: 'recordTime',
                    },
                    {
                        title: '操作',
                        align: "center",
                        fixed: "right",
                        width: 80,
                        scopedSlots: { customRender: 'action' }
                    }
                ]
            }
        },
        // 计算属性，会监听依赖属性值随之变化
        computed: {
            ...mapGetters([''])
        },
        // 监控data中的数据变化
        watch: {},
        // 生命周期 - 创建完成（可以访问当前this实例）
        created() {
            const time = moment().format('YYYY-MM-DD')
            this.queryParams = {
                startTime: time + ' 00:00:00',
                endTime: time + ' 23:59:59'
            }
        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {

        },
        // 方法集合
        methods: {
            moment,
            queryData() {
                this.$refs.table.loadData()
            },
            modalFormOk() {
                this.queryData()
            },
            //查看巡检报告
            handleViewPatrolReport(record) {
                this.$refs.reportForm.edit({ ...record })
                this.$refs.reportForm.title = '巡检报告'
                this.$refs.reportForm.disableSubmit = true
            },
            //人工复核
            handleManualReview(record) {
                this.$refs.modalForm.edit(record)
                this.$refs.modalForm.title = '人工复核'
                this.$refs.modalForm.disableSubmit = false
            },
            //巡检路线
            handlePatrolRoute(record) {
                this.$message.warning('暂未开放')
            },
            //告警信息
            handleAlarmInformation(record) {
                this.$router.push({ path: '/alert/center', query: record })
            },
        }
    }
</script>

<style lang='scss' scoped>


</style>